import React, { useState, useEffect } from 'react';
import { FiLayers } from 'react-icons/fi';
import api from '../../utils/api';

const font = "'Outfit', sans-serif";
const BL = '#6366f1';
const C = { text: '#1e1b4b', sub: '#6b7280', border: '#e0e7ff', bg: '#eef2ff', white: '#fff' };

const TeacherAssignments = () => {
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get('/api/teacher/assignments')
            .then(r => setAssignments(r.data.assignments || []))
            .catch(() => { })
            .finally(() => setLoading(false));
    }, []);

    if (loading) return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 300, flexDirection: 'column', gap: 14 }}>
            <div style={{ width: 36, height: 36, border: '4px solid #e0e7ff', borderTopColor: BL, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <p style={{ color: C.sub, fontFamily: font }}>Loading assignments…</p>
        </div>
    );

    return (
        <div style={{ width: '100%', fontFamily: font }}>
            <h1 style={{ fontSize: 20, fontWeight: 900, color: C.text, margin: '0 0 22px' }}>📋 My Batch Assignments</h1>
            <p style={{ color: C.sub, fontSize: 13, marginBottom: 20 }}>These batches and subjects have been assigned to you by the admin. You can create exam papers for these batches.</p>

            {assignments.length === 0 ? (
                <div style={{ background: C.white, borderRadius: 18, border: `1.5px solid ${C.border}`, padding: '60px 24px', textAlign: 'center' }}>
                    <FiLayers size={48} color="#c7d2fe" style={{ marginBottom: 16 }} />
                    <h3 style={{ color: C.text, fontWeight: 700, margin: '0 0 8px' }}>No assignments yet</h3>
                    <p style={{ color: C.sub, fontSize: 13 }}>The admin has not assigned any batches to you yet. Please contact your administrator.</p>
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
                    {assignments.map((a, i) => (
                        <div key={i} style={{ background: C.white, borderRadius: 16, border: `1.5px solid ${C.border}`, padding: '18px 20px', boxShadow: '0 3px 12px rgba(99,102,241,0.07)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                <div style={{ width: 42, height: 42, borderRadius: 12, background: 'linear-gradient(135deg,#818cf8,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0 }}>
                                    <FiLayers size={18} />
                                </div>
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 800, color: C.text }}>{a.subject_name}</div>
                                    <div style={{ fontSize: 11, color: BL, fontWeight: 600 }}>{a.subject_code}</div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                {[
                                    { l: 'Batch', v: a.batch_name },
                                    { l: 'Semester', v: `Semester ${a.semester}` },
                                    { l: 'Department', v: a.department },
                                    { l: 'Academic Year', v: a.academic_year },
                                ].map(row => (
                                    <div key={row.l} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                        <span style={{ color: C.sub, fontWeight: 600 }}>{row.l}</span>
                                        <span style={{ color: C.text, fontWeight: 700 }}>{row.v}</span>
                                    </div>
                                ))}
                            </div>
                            <div style={{ marginTop: 12, padding: '6px 12px', borderRadius: 8, background: C.bg, textAlign: 'center', fontSize: 11, color: BL, fontWeight: 700 }}>
                                Assigned by Admin
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TeacherAssignments;
